import React from "react";

const selectorStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  background: "#f8fafc",
  border: "1px solid #e2e8f0",
  borderRadius: 8,
  padding: "6px 12px",
  fontSize: 13,
  fontWeight: 600,
  color: "#334155",
  cursor: "pointer",
};

const selectStyle = {
  border: "none",
  background: "transparent",
  fontSize: 13,
  fontWeight: 600,
  color: "#334155",
  cursor: "pointer",
  outline: "none",
  paddingRight: 4,
};

export default function CurrencySelector({ value, onChange, rates }) {
  if (!Array.isArray(rates) || rates.length === 0) return null;

  return (
    <div style={selectorStyle}>
      <span style={{ fontSize: 15 }}>💱</span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={selectStyle}
      >
        {rates.map((r) => (
          <option key={r.currency} value={r.currency}>
            {r.symbol} {r.currency} — {r.name}
          </option>
        ))}
      </select>
    </div>
  );
}
